/* unplugin-vue-components disabled */import { render } from "./Thumbnail.vue?vue&type=template&id=8c738694"
import script from "./Thumbnail.vue?vue&type=script&lang=js"
export * from "./Thumbnail.vue?vue&type=script&lang=js"

import "./Thumbnail.vue?vue&type=style&index=0&id=8c738694&lang=scss&sccoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__